import { render } from "./currency-form.vue?vue&type=template&id=66c9d671&ts=true"
import script from "./currency-form.ts?vue&type=script&lang=ts"
export * from "./currency-form.ts?vue&type=script&lang=ts"

import "./currency-form.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__